import { Box, Typography } from '@mui/material';
import { signUpToolPageTexts } from 'src/common/config/TextMessage';
import { signUpToolPageSxs } from './signupSx';
import { AvatarGroupModule } from 'src/common/AvatarGroupsModule';
import { useEffect, useState } from 'react';

const SignUpToolPage = () => {
  const [maxHeight, setMaxHeight] = useState(
    window.innerWidth >= 1600 ? '90%' : '400px'
  );

  useEffect(() => {
    const handleResize = () => {
      setMaxHeight(window.innerWidth >= 1600 ? '90%' : '400px');
    };

    // Attach event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      <Box
        className="hidden relative md: bg-themeBlue md:flex md:flex-col"
        sx={{
          ...signUpToolPageSxs?.mainContainer
        }}
      >
        <Box sx={signUpToolPageSxs?.firstContainerSx}>
          <Typography sx={signUpToolPageSxs?.titleSx}>
            {signUpToolPageTexts?.title}
          </Typography>
          <Typography sx={signUpToolPageSxs?.descSx}>
            {signUpToolPageTexts?.desc}
            <span style={signUpToolPageSxs?.descSpanSx}>
              {signUpToolPageTexts?.spanText}
            </span>
            {signUpToolPageTexts?.descOne}
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 'none',
            width: 'auto',
            overflow: 'hidden',
            marginBottom: maxHeight == '90%' ? '-60px' : '0px'
          }}
        >
          <img
            src={process.env.PUBLIC_URL + signUpToolPageTexts?.singUpBg}
            loading="lazy"
            style={{
              width: '100%', // Full width
              maxHeight: maxHeight,
              objectFit: 'contain', // Maintain aspect ratio, fill container,
              paddingLeft: '30px',
              paddingRight: '30px'
            }}
          />
        </Box>
        <Box className="mr-6">
          <Typography sx={signUpToolPageSxs?.footerTextSx}>
            {signUpToolPageTexts?.footerText}
          </Typography>
          <Box sx={signUpToolPageSxs?.avatarBoxSx}>
            <AvatarGroupModule />
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default SignUpToolPage;
